class Time {
	constructor() {
		this.weekConfig = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];
		this.monthConfig = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
	}
	get wee() {
		const date = new Date();
		date.setHours(0, 0, 0, 0);
		const timestamp = Date.parse(date) / 1000;
		const localtime = this.ts2lt(timestamp);
		return {
			localtime,
			timestamp
		};
	}
	get now() {
		const date = new Date();
		const timestamp = Date.parse(date) / 1000;
		const localtime = this.ts2lt(timestamp);
		return {
			localtime,
			timestamp
		};
	}
	get year() {
		return this.parse(this.now.timestamp).year || 0;
	}
	get month() {
		return this.parse(this.now.timestamp).month || 0;
	}
	get date() {
		return this.parse(this.now.timestamp).date || 0;
	}
	get hour() {
		return this.parse(this.now.timestamp).hour || 0;
	}
	get minute() {
		return this.parse(this.now.timestamp).minute || 0;
	}
	get second() {
		return this.parse(this.now.timestamp).second || 0;
	}
	get ymd() {
		return this.parse(this.now.timestamp).ymd || '';
	}
	get hms() {
		return this.parse(this.now.timestamp).hms || '';
	}
	get week() {
		return this.parse(this.now.timestamp).week || 0;
	}
	get week_name() {
		return this.weekConfig[this.parse(this.now.timestamp).week] || '';
	}
	get month_name() {
		return this.monthConfig[this.parse(this.now.timestamp).month - 1] || '';
	}
	ts2lt(timestamp = 946656000) {
		if (timestamp) {
			return this.parse(timestamp).localtime || '';
		}
		return '';
	}
	lt2ts(localtime = '2000-01-01') {
		if (localtime) {
			return parseInt(new Date(localtime.replace(/\-/g, '/')).getTime()) / 1000;
		}
		return 0;
	}
	age(time = 946656000) {
		return this.year - (this.parse(time).year || (this.year + 1)) + 1;
	}
	parse(time = 946656000) {
		const data = Object.create(null);
		const timestamp = this.parseParam(time);
		if (timestamp && (typeof timestamp === 'number') && (timestamp > 0)) {
			const date = new Date(timestamp * 1000);
			data['year'] = date.getFullYear();
			data['month'] = date.getMonth() + 1;
			data['date'] = date.getDate();
			data['hour'] = date.getHours();
			data['minute'] = date.getMinutes();
			data['second'] = date.getSeconds();
			data['week'] = date.getDay();
			let m = data['month'] < 10 ? `0${data['month']}` : data['month'];
			let d = data['date'] < 10 ? `0${data['date']}` : data['date'];
			let h = data['hour'] < 10 ? `0${data['hour']}` : data['hour'];
			let mm = data['minute'] < 10 ? `0${data['minute']}` : data['minute'];
			let s = data['second'] < 10 ? `0${data['second']}` : data['second'];
			data['timestamp'] = timestamp;
			data['localtime'] = `${data['year']}-${m}-${d} ${h}:${mm}:${s}`;
			data['week_name'] = this.weekConfig[data['week']];
			data['month_name'] = this.monthConfig[data['month'] - 1];
			data['ymd'] = `${data['year']}-${m}-${d}`;
			data['hms'] = `${h}:${mm}:${s}`;
		}
		return data;
	}
	detail(data = {}) {
		const year = data['year'] || this.year;
		const month = data['month'] || this.month;
		const date = data['date'] || 1;
		const hour = data['hour'] || 0;
		const minute = data['minute'] || 0;
		const second = data['second'] || 0;
		const _date = new Date();
		_date.setFullYear(year, month - 1, date);
		_date.setHours(hour, minute, second, 0);
		return this.parse(Date.parse(_date) / 1000);
	}
    simplify(time = 946656000) {
        // 时间简化
		const timestamp = this.parseParam(time);
        const { year, month, date, hms } = this.parse(timestamp);
        if (year !== this.year) {
            return { year, month, date, hms };
        }
        if (month !== this.month) {
            return { month, date, hms };
        }
        if (date !== this.date) {
            return { date, hms };
        }
        return { hms };
    }
	num2time(number = 60, mode = 'lower', join = ':') {
        // 时长转时间显示
		// upper (如果小于10前面加0)
		// lower (如果小于10前面不加0)
		// test 119349 4149 69 0
		if (number && (typeof number === 'number') && (number > 0)) {
			let d = number >= 86400 ? Math.floor(number / 86400) : 0;
			let h = number >= 3600 ? Math.floor(number % 86400 / 3600) : 0;
			let m = number >= 60 ? Math.floor(number % 86400 % 3600 / 60) : 0;
			let s = number > 0 ? Math.floor(number % 86400 % 3600 % 60) : 0;
			if (mode === 'upper') {
				s = (d || h || m) ? (s < 10 ? `0${s}` : s) : s;
				m = (d || h) ? (m < 10 ? `0${m}` : m) : m;
				h = d ? (h < 10 ? `0${h}` : h) : h;
			}
			const data = [d, h, m, s];
			if (d) {
				return [d, h, m, s].join(join);
			}
			if (h) {
				return [h, m, s].join(join);
			}
			if (m) {
				return [m, s].join(join);
			}
			return s || (mode === 'upper' ? '00' : '0');
		}
		return mode === 'upper' ? '00' : '0';
	}
	parseParam(time = null) {
		// time可以是时间戳也可以是本地时间，默认是当前时间，返回一个时间戳
		if (typeof time === 'string') {
			return this.lt2ts(time);
		}
		if (typeof time === 'number') {
			return time;
		}
		return this.now.timestamp;
	}
}

export default new Time